import React, { useEffect, useState, Suspense, lazy } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';

const LoginPage        = lazy(() => import('./pages/LoginPage'));
const Dashboard        = lazy(() => import('./pages/Dashboard'));
const ExerciceDetail   = lazy(() => import('./pages/ExerciceDetail'));
const ExerciceForm     = lazy(() => import('./pages/ExerciceForm'));
const FeuilleBuilder   = lazy(() => import('./pages/FeuilleBuilder'));
const TexImportWizard  = lazy(() => import('./pages/TexImportWizard'));

function PageLoader() {
  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Chargement…</span>
      </div>
    </div>
  );
}

export default function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const auth = localStorage.getItem('mm_token');
    setIsAuthenticated(!!auth);
    if (auth && location.pathname === '/') navigate('/dashboard');
  }, [navigate, location]);

  if (!isAuthenticated) {
    return (
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="*" element={<LoginPage onLogin={() => setIsAuthenticated(true)} />} />
        </Routes>
      </Suspense>
    );
  }

  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/exercice/new" element={<ExerciceForm />} />
        <Route path="/exercice/:id/edit" element={<ExerciceForm />} />
        <Route path="/exercice/:id" element={<ExerciceDetail />} />
        <Route path="/feuille" element={<FeuilleBuilder />} />
        <Route path="/import/tex" element={<TexImportWizard />} />
        <Route path="*" element={<Dashboard />} />
      </Routes>
    </Suspense>
  );
}
